import { render, staticRenderFns } from "./addvideos.vue?vue&type=template&id=526ce637"
import script from "./addvideos.vue?vue&type=script&lang=js"
export * from "./addvideos.vue?vue&type=script&lang=js"
import style0 from "./addvideos.vue?vue&type=style&index=0&id=526ce637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports